module.exports = __webpack_public_path__ + "img/horizontal_3_4_8023.e580ed7c.png";